import React from 'react';
import { useBookings } from '../../../../hooks';
import { quoteRequestsColumns, Table } from '../../../commons/Table';
import { Card } from '../../../ui/Card';

const Quotes = () => {
  const { bookings, loading } = useBookings();
  const filteredQuotes = bookings.filter((booking) => booking.refNo);
  
  return (
    <div className='space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-700'>
      {/* Page Header */}
      <div className='flex flex-col md:flex-row md:items-center justify-between gap-4'>
        <div>
          <h1 className='text-2xl font-bold text-gray-900 dark:text-white'>
            Quote Requests
          </h1>
          <p className='text-gray-500 dark:text-gray-400 mt-1 text-sm md:text-base'>
            Track and manage custom safari price estimations.
          </p>
        </div>
      </div>

      {/* Main Content Card */}
      <Card variant='glass' className='overflow-hidden border-none shadow-xl shadow-gray-200/50 dark:shadow-none'>
        {/* @ts-ignore */}
        <Table 
          columns={quoteRequestsColumns} 
          data={filteredQuotes} 
          loading={loading} 
          hideActions 
          recordName='Quotes'
          placeholder='Search by reference or customer...'
        />
      </Card>
    </div>
  );
};

export default Quotes;
